import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AddImageModel } from '../../../../model/builk/image-app/add-image.model';
import { ImageAppService } from '../../../../service/api/builk/image-app.service';

@Component({
  selector: 'app-image-app-add',
  templateUrl: './image-app-add.component.html',
  styleUrls: ['./image-app-add.component.scss']
})
export class ImageAppAddComponent implements OnInit {
  @ViewChild("template") template: TemplateRef<any>;
  @ViewChild('imageInput') imageInput: ElementRef;

  model: AddImageModel = new AddImageModel();
  modalRef: BsModalRef;
  files: FileList;
  name: string = "";
  link: string = "";
  imageSrc;
  @Output() isSaved = new EventEmitter();
  @Output() okEvent = new EventEmitter();
  constructor(
    private modalService: BsModalService,
    private readonly imageAppService: ImageAppService
  ) { }

  ngOnInit() {
  }
  

  openModal(): void {
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-lg"
    });
  }

  save () {
    //save
    console.log(this.files);
    this.model.file = this.files[0];
    this.model.name = this.name;
    this.model.linkUrl = this.link;
    
    this.imageAppService.addImage(this.model).subscribe(res => {
      this.okEvent.emit(true);
      this.modalRef.hide();
    }, (err) => {

    });
  }


  getImage() {
    if(this.files.length > 0) {
      const file = this.files[0];
      const reader = new FileReader();
      reader.onload = e => this.imageSrc = reader.result;
      reader.readAsDataURL(file);
    }
  }
  uploadFile(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    if (fileList) {
      this.files = fileList;
      this.getImage();
    }
  }
}
